import { Navigate } from "react-router";
import pages from "@/config/pages";
import { useDebugFlags } from "@/hooks/useDebugFlags";
import ProductDefinitionsPage from "./ProductDefinitionsPage";

/**
 * Renders the product catalog only when `debug.toggleProductCatalouge()` has
 * been used to enable navigation in this tab session; otherwise redirects to
 * the admin dashboard (same gate as hiding the dashboard button).
 */
export const ProductDefinitionsRouteGate = () => {
	const productCatalogueNavVisible = useDebugFlags(
		(s) => s.productCatalogueNavVisible,
	);

	if (!productCatalogueNavVisible) {
		return <Navigate to={pages.Admin} replace />;
	}

	return <ProductDefinitionsPage />;
};
